/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-06-02 09:35:04
 */
// const crypto = require('crypto');
import CryptoJS from 'crypto-js'
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export const getUrlParams = (url) => {
  let a = url.split('&'),
      res = {}
  for (let i of a) {
    let key = i.split('=')[0],
        val = i.split('=')[1]
    if (key && val !== undefined) res[key] = val
  }
  return res
}


//获取cookie
export const getCookie = (name) => {
	let arrCookie = document.cookie.split(";")
	for (let i = 0; i < arrCookie.length; i++) {
	  let arr = arrCookie[i].split("=") //从 = 的位置 分割每对cookie
	  if (arr[0].replace(/(^\s*|\s*$)/g, "") === name) { //存在此cookie
		return (arr[1] ? decodeURIComponent(arr[1]) : null) //若值不为空，返回此值，否则返回null
	  }
	}
	return null
  } 
  //设置cookie
  export const setCookie = (name, val, time = 7 * 24 * 60 * 60 * 1000, path, domain) => {
	let exp = new Date(),
		p = path ? ';path=' + path : ';path=/',
		d = domain ? ';domain=' + domain : ''
	exp.setTime(exp.getTime() + time) //默认7天过期, 删除cookie传入负值即可
	document.cookie = name + "=" + encodeURIComponent(val) + ";expires=" + exp.toGMTString() + p + d
  }
// 数据DES加密
export const aseEncode = (word,keyStr)=>{
  var keyHex = CryptoJS.enc.Utf8.parse(keyStr);
  var encrypted = CryptoJS.DES.encrypt(word, keyHex, {
  mode: CryptoJS.mode.ECB,
  padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString();
}
// 数据DES解密
export const aseDecode = (word,keyStr)=>{
  var keyHex = CryptoJS.enc.Utf8.parse(keyStr);
  var decrypted = CryptoJS.DES.decrypt({
  ciphertext: CryptoJS.enc.Hex.parse(word)
  }, keyHex, {
  mode: CryptoJS.mode.ECB,
  padding: CryptoJS.pad.Pkcs7
  });
  var result_value = decrypted.toString(CryptoJS.enc.Utf8);
  return result_value;
}
export const IEVersion = () => {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
  var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
  var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
  if(isIE) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      reIE.test(userAgent);
      var fIEVersion = parseFloat(RegExp["$1"]);
      if(fIEVersion == 7) {
          return 7;
      } else if(fIEVersion == 8) {
          return 8;
      } else if(fIEVersion == 9) {
          return 9;
      } else if(fIEVersion == 10) {
          return 10;
      } else {
          return 6;//IE版本<=7
      }   
  } else if(isEdge) {
      return 'edge';//edge
  } else if(isIE11) {
      return 11; //IE11  
  }else{
      return -1;//不是ie浏览器
  }
}



// WEBPACK FOOTER //
// ./src/js/utils.js